export const BADGE_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right',
};
